import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getCommonPartsReducer = (state: RootState) => state.commonPartsReducer;

export const commonPartsReducerSelector = createSelector(getCommonPartsReducer, (res) => res);
